import { Injectable } from '@angular/core';
import { TranslationLocalService } from 'gung-standard';
import seTranslations from '../i18n/se.json';
import enTranslations from '../i18n/en.json';
import { HttpBackend, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SjoborgTranslationLocalService extends TranslationLocalService {
  constructor(httpClient: HttpClient, httpBackend: HttpBackend) {
    super(httpClient, httpBackend);
  }

  protected async getCustTranslations(lang: string): Promise<any> {
    if (lang === 'se') {
      return seTranslations;
    }
    if (lang === 'en') {
      return enTranslations;
    }
    return {};
  }
}
